module.exports = __webpack_public_path__ + "static/media/gain_sense.f66a9d65.png";